


















import { Component, Vue, Prop } from 'vue-property-decorator';
import { getNoticeByRoomId } from 'apiUtils/ZnPlayer';
import * as types from '@/store/types';
@Component({
  components: {
  },
})
export default class NoticeSlider extends Vue {
   @Prop({
    type: String,
    required: true,
    default: '',
  }) private roomId!: string;
  @Prop({
    type: String,
    required: true
  }) private sid!: string;
  private showContent = false
  private showCurrent = 0
  private timer: any = null
  public mounted() {
    this.getNoticeList()
  }
  public beforeDestroy () {
    clearInterval(this.timer)
  }
  private async getNoticeList() {
    this.$store.dispatch('getNoticeList', {roomId: this.roomId, sid: this.sid})
    this.timer = setInterval(() => {
      if (this.$store.state.noticeList.length <= 1) { return }
      if (this.showCurrent === this.$store.state.noticeList.length - 1) {
        this.showCurrent = 0
      } else {
        this.showCurrent += 1
      }
    }, 3000)
  }

  private onClickShowNotice (showContent: boolean) {
    this.showContent = showContent
  }

  private get contentWord () {
    return this.$store.state.noticeList[this.showCurrent]
  }

  private get showNoticeList () {
    return this.$store.state.noticeList.length > 0
  }

}
